import React, { PureComponent } from 'react';
import { Country } from '~/Api/Country';
import CountryIcon from '~/UI/CountryIcon';

import { DataSource } from '~/Api/DataSource';

import styles from './styles.less';
import { VirtualPack } from '~/Api/Analytics/VirtualBrand';
import { AnalyticDataSources } from '~/Api/Analytics/VirtualBrand/mapAnalyticVirtualBrand';

interface Props {
	virtualPack: VirtualPack;
	virtualPackAvailability: { [countryCode: string]: AnalyticDataSources };
	countries: Country[];
	styles: {
		table: string;
		tableHeading: string;
		tableContentHeading: string;
		tableContent: string;
		item: string;
		grayItem: string;
		countryIcon: string;
		dataSource: string;
	};
}

export default class AvailabilityTable extends PureComponent<Props> {
	static defaultProps = {
		styles,
	};

	render() {
		const { virtualPack, virtualPackAvailability, countries, styles } = this.props;

		return (
			<div className={styles.table}>
				<h3 className={styles.tableHeading}>{virtualPack.distinctName}</h3>
				<div className={styles.tableContentHeading}>Country</div>
				<div className={styles.tableContent}>
					{countries.map((country) => {
						const countryDataSources: AnalyticDataSources = virtualPackAvailability[country.alpha2] || [];

						return countryDataSources.map(({ country, dataSource }) =>
							dataSource ? (
								<div
									className={styles.item}
									key={`${dataSource.type}-${dataSource.shortName}-${dataSource.country.name}-${country.alpha2}`}
								>
									<span className={styles.countryIcon}>
										<CountryIcon code={country.alpha2} name={country.name} />
									</span>
									{country.alpha2}
									<div className={styles.dataSource}>{dataSource.shortName}</div>
								</div>
							) : (
								<div className={styles.item} key={`${country.alpha2}`}>
									<span className={styles.countryIcon}>
										<CountryIcon code={country.alpha2} name={country.name} />
									</span>
									{country.alpha2}
									<div className={styles.dataSource}> </div>
								</div>
							)
						);
					})}
				</div>
			</div>
		);
	}
}
